module.exports = __webpack_public_path__ + "img/detail-address.f800c072.svg";